import { Observable, Subject } from 'rxjs';

export class DynamicDialogRef {
	constructor() { }

	close(result?: any) {
		this._onClose.next(result);
    }
    
    destroy() {
		this._onDestroy.next();
	}

	submit(){
		this._onSubmit.next();
	}

	private readonly _onSubmit = new Subject<any>();
    onSubmit: Observable<any> = this._onSubmit.asObservable();

	private readonly _onClose = new Subject<any>();
    onClose: Observable<any> = this._onClose.asObservable();

    private readonly _onDestroy = new Subject<any>();
	onDestroy: Observable<any> = this._onDestroy.asObservable();
}